"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  border: 0;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  background: none;\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reset = exports.ResetButton = void 0;

var styledTypes_1 = require("./styledTypes");

exports.ResetButton = styledTypes_1.styled.button(_templateObject());
exports.Reset = {
  Button: exports.ResetButton
};